
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import STPEnergyConsumptionDataPopup from './STPPreventiveEnergyConsumptionDataPopup'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { STPEnergyStatusDDL } from '../../../../../../Components/CommonDDL/STPEnergyStatusDDL'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { STPEnergyConsumptionDeleteAPI, STPEnergyConsumptionTableDataAPI, STPEnergyConsumptionTableExportDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveEnergyConsumptionSlice'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../../Helper/Loading'
import { TableNote } from '../../../../../../Components/Note/Note'
import STPPowerFailureDataPopup from './STPPreventiveEnergyConsumptionPowerFailurePopup'
import { STPPreventiveEnergyConsumptionExportData } from './STPPreventiveEnergyConsumptionExportPage'
import { STPPreventiveEnergyConsumptionPowerFailureExportData } from './STPPreventiveEnergyConsumptionPowerFailureExportPage'




export default function STPPreventiveEnergyConsumptionData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails

    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [STPEnergyConsumptionPopupShow, setSTPEnergyConsumptionPopupShow] = useState()
    const [STPPowerFailurePopupShow, setSTPPowerFailurePopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? (moment(date).format('YYYY-MM') == moment().format('YYYY-MM') ? moment().format('YYYY-MM-DD') : moment(date).endOf('month').format('YYYY-MM-DD')) : moment().format('YYYY-MM-DD'))

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [EnergyStatus, setEnergyStatus] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleEditOnClick = (item) => {
        setSTPEnergyConsumptionPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    // const handleEditOnClickPowerPopup = () => {
    //     setSTPPowerFailurePopupShow(true)
    //     setapiFlag('Update')
    //     setrowData()
    // }

    const handleOnCloseClick = () => {
        setSTPEnergyConsumptionPopupShow(false)
        setSTPPowerFailurePopupShow(false)
    }
    // const handleOnCloseClickPowerPopup = () => {
    //     setSTPPowerFailurePopupShow(false)
    // }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setEnergyStatus({
            ...EnergyStatus,
            ID: EnergyStatus.DDL[0].value,
            Label: EnergyStatus.DDL[0].label,
        })

        // setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        // setToDate(moment().format('YYYY-MM-DD'))
    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_IndicatorSTPEnergyID: EnergyStatus.ID ? EnergyStatus.ID : 0,
            M_UserID: UserID,
            Flag: 'Grid',
            token: token,
            From: From,
            To: To,
            STPPreventiveEnergyExport: STPPreventiveEnergyExport
        }
        dispatch(STPEnergyConsumptionTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear, EnergyStatus.ID])
    const { tableData, isLoading } = useSelector(state => state.STPEnergyConsumptionTableData)

    const STPPreventiveEnergyExport = () => {
        const data = {
            M_WardID: WardName.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_IndicatorSTPEnergyID: EnergyStatus.ID ? EnergyStatus.ID : 0,
            M_UserID: UserID,
            Flag: 'Report',
            token: token,
            From: '1',
            To: '99999',
        }
        dispatch(STPEnergyConsumptionTableExportDataAPI({ data }))
    }
    // , [IsPost, isSearch, IsClear, EnergyStatus.ID])
    const { ExportTableData, isExportLoading } = useSelector(state => state.STPEnergyConsumptionTableExportData)


    const handleDeleteApi = (item) => {
        const data = {
            T_STP_EnergyConsumptionID: item.t_stP_EnergyConsumptionID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(STPEnergyConsumptionDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.STPEnergyConsumptionDelete)

    // console.log('first,', ExportTableData, ExportTableData.table)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId} />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    <div className="page-header ">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Energy Consumption</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <>
                                                {
                                                    EnergyStatus.ID === 18 ?
                                                        <STPPreventiveEnergyConsumptionPowerFailureExportData
                                                            ExcelData={ExportTableData}
                                                            name='Power Failure'
                                                            FromDate={FromDate}
                                                            ToDate={ToDate}
                                                        // searchName={searchName}
                                                        />
                                                        :
                                                        <STPPreventiveEnergyConsumptionExportData
                                                            ExcelData={ExportTableData}
                                                            name='Energy Consumption'
                                                            FromDate={FromDate}
                                                            ToDate={ToDate}
                                                        // searchName={searchName}
                                                        />
                                                }
                                            </>


                                    }
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12 mb-5">

                                        <div className="row py-1 rounded2">

                                            <div className="col-lg-2 col-md-4">
                                                <label for=""><b>From Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="FromDate"
                                                    value={FromDate}
                                                    onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                />

                                            </div>

                                            <div className="col-lg-2 col-md-4">
                                                <label for=""><b>To Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="ToDate"
                                                    value={ToDate}
                                                    onChange={(e) => setToDate(e.target.value)}
                                                    min={FromDate}
                                                />

                                            </div>

                                            <div className="col-lg-2 col-md-4">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-4">
                                                <STPEnergyStatusDDL
                                                    EnergyStatus={EnergyStatus}
                                                    setEnergyStatus={setEnergyStatus}
                                                />

                                            </div>
                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>

                                        <TableNote />
                                        {
                                            EnergyStatus.ID === 18 ?
                                                <>
                                                    <div className="row mob_table table-responsive pt-1 mb-5 " >

                                                        <table id="totalordergenerated"
                                                            cellPadding="0"
                                                            cellSpacing="0"
                                                            border="0"
                                                            className="table table-bordered">

                                                            <thead>
                                                                <tr>
                                                                    <th className="sr_no_col">Sr No.</th>
                                                                    <th>Reading Date</th>
                                                                    <th>MCC No.</th>
                                                                    <th>Power Off Time</th>
                                                                    <th>Power On Time</th>
                                                                    <th>Diesel Consumption</th>
                                                                    <th className='action_icon action-col'>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                        <tr>
                                                                            <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                            <td className="date-col">{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                            <td>{item.energyMPCNo ? item.energyMPCNo : '0'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.powerOffTime ? item.powerOffTime : '-'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.powerOnTime ? item.powerOnTime : '-'}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.dieselConsumtion ? item.dieselConsumtion : '0'}</td>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {
                                                                                    (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                                        <>
                                                                                            <span >

                                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                                >
                                                                                                </i>
                                                                                            </span>
                                                                                            <span>
                                                                                                <DeletePopup
                                                                                                    open={DeletePopupShow}
                                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                                    item={item}
                                                                                                />
                                                                                            </span>
                                                                                        </>
                                                                                        :
                                                                                        '-'
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )) :
                                                                        <td colSpan={15}>No data found</td>
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div></>
                                                :
                                                <>
                                                    <div className="row mob_table table-responsive pt-1 ">

                                                        <table id="totalordergenerated"
                                                            cellPadding="0"
                                                            cellSpacing="0"
                                                            border="0"
                                                            className="table table-bordered">

                                                            <thead>
                                                                <tr>
                                                                    <th className="sr_no_col">Sr No.</th>
                                                                    <th>Reading Date</th>
                                                                    <th>Energy Number </th>
                                                                    <th>Today’s Reading </th>
                                                                    <th className='action_icon action-col'>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                        <tr>
                                                                            <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                            <td className="date-col">{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                            <td>{item.energyMPCNo ? item.energyMPCNo : '0'}</td>
                                                                            <td style={{ textAlign: "right", width: '15%' }}>{item.todayReading ? item.todayReading : '0'}</td>
                                                                            <td style={{ textAlign: "center" }}>
                                                                                {
                                                                                    (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                                        <>
                                                                                            <span >

                                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                                >
                                                                                                </i>
                                                                                            </span>
                                                                                            <span>
                                                                                                <DeletePopup
                                                                                                    open={DeletePopupShow}
                                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                                    item={item}
                                                                                                />
                                                                                            </span>
                                                                                        </>
                                                                                        :
                                                                                        '-'
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )) :
                                                                        <td colSpan={15}>No data found</td>
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </>

                                        }

                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    STPEnergyConsumptionPopupShow ?
                        <STPEnergyConsumptionDataPopup
                            open={STPEnergyConsumptionPopupShow}
                            // popupHeading="Work Name"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            EnergyStatus={EnergyStatus}
                        />
                        : <></>
                }
                {/* {
                    STPPowerFailurePopupShow ?
                        <STPPowerFailureDataPopup
                            open={STPPowerFailurePopupShow}
                            popupHeading="Work Name"
                            // handleIsPost={handleIsPost}
                            handleOnCloseClickPowerPopup={handleOnCloseClickPowerPopup}
                            Flag={apiFlag}
                        // rowData={rowData}
                        />
                        : <></>
                } */}
            </div>
        </div>



    )
}